import Common from '../common/CommonPowerbook';

class TmplObjectMagic {

    constructor() {
        this.comm = Common.instance;
    }


     make(_d){
         return `
<section class="object object-item">
    <header class="object__header">
        <img class="object__icon" src="${this.comm.staticImgURL}/powerbook/lineage/${_d.image}" alt="">
        <span class="object__name"><a class="item-grade--1" href="${this.comm.powerbookURL}/${_d.name}">${_d.name}</a></span>
    </header>
    <article class="object__attribute">
        <table>
            <tbody>
                <tr>
                    <th scope="col">종류</th>
                    <td><a href="${this.comm.powerbookURL}/${_d.type}">${_d.type}</a></td>
                </tr>
                <tr>
                    <th scope="col">마법 등급</th>
                    <td>${_d.magic_level}</td>
                </tr>
                <tr>
                    <th scope="col">마법 단계</th>
                    <td>${_d.magic_grade}</td>
                </tr>
                <tr>
                    <th scope="col">소모 MP</th>
                    <td>${_d.mp}</td>
                </tr>
                <tr>
                    <th scope="col">소모 HP</th>
                    <td>${_d.hp}</td>
                </tr>
                <tr>
                    <th scope="col">마법재료</th>
                    <td>${_d.magic_material||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">지속시간</th>
                    <td>${_d.effect_time||'-'}</td>
                </tr>
                
                <tr>
                    <th scope="col">대상</th>
                    <td>${_d.target||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">성향</th>
                    <td>${_d.alignment||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">성향치 변화</th>
                    <td>${_d.alignment_count||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">속성</th>
                    <td>${_d.attribute||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">설명</th>
                    <td>${_d.description||'-'}</td>
                </tr>
            </tbody>
        </table>
    </article>
</section>`
     }


}


export default TmplObjectMagic;




// WEBPACK FOOTER //
// ./lineage/TmplObjectMagic.js